import React from "react"
import { Route, Redirect, RouteProps, RouteComponentProps } from "react-router-dom"
import { useUserStatus } from "../../../subscriptions-web/hooks/use-user-status"

export const ConfirmEmailRoute = ({
	component: RouteComponent,
	...restProps
}: { component: React.ComponentType<any> } & RouteProps) => {
	const {
		userSignedInAnonymously,
		userSignedInWithEmailNotVerified,
		userSignedInWithEmailVerified,
		isProSubscriptionActive,
	} = useUserStatus()

	const renderRouter = (routeProps: RouteComponentProps<any>) => {
		if (userSignedInWithEmailVerified) {
			return <Redirect to={"/account"} />
		} else if (userSignedInAnonymously && isProSubscriptionActive) {
			return <RouteComponent {...routeProps} />
		} else if (userSignedInWithEmailNotVerified) {
			return <RouteComponent {...routeProps} />
		} else {
			return <Redirect to={"/signin"} />
		}
	}

	return <Route {...restProps} render={renderRouter} />
}
